import history from '../img/features/history.jpg'
import food from '../img/features/hudut.jpg'
import music from '../img/features/music.jpg'
import language from '../img/features/language.jpg'
import traditions from '../img/features/traditions.jpg'

const FeatureSections = [
    {
        id: 1,
        image: history,
        title: 'History',
        content: 'The Afro-Caribbean Garifuna people originated with the arrival of West African slaves who washed ashore on the Caribbean island of St. Vincent around 1635 while likely on their way to New World mines and plantations.',
        route: '/history'
    },
    {
        id: 2,
        image: food,
        title: 'Food',
        content: 'Garifuna food is traditionally based on the staple foods of cassava, plantain and banana, combined with fish and other seafood.',
        route: '/food'
    },
    {
        id: 3,
        image: music,
        title: 'Music',
        content: 'Garifuna music is an ethnic music with African and Arawak elements, originated by an Afro Indigenous group known as the Garifuna people, pre to their exile to Central America from Saint Vincent And The Grenadines.',
        route: '/music'
    },
    {
        id: 4,
        image: language,
        title: 'Language',
        content: 'Garifuna is a minority language widely spoken in villages of Garifuna people in the western part of the northern coast of Central America.',
        route: '/language'
    },
    {
        id: 5,
        image: traditions,
        title: 'Traditions', 
        content: 'The Garifuna have a rich heritage with roots in both African and local cultures. Their traditional music includes work songs, hymns, lullabies, ballads, and healing songs. ',
        route: 'traditions'
    },
]

export default FeatureSections;

// It shows an African influence in call-and-response song patterns and complex drum rhythms. Some songs are sung during daily tasks, such as the baking of cassava bread (ereba)